
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/year-at-a-glance",
      function () {
        return require("private-next-pages/learn/year-at-a-glance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/year-at-a-glance"])
      });
    }
  